import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';


@Injectable()
export class RestInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,    
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {         

    return next.handle(request).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          this.authenticationService.logout();
          this.router.navigate(['/login-user']);
        }
        if (err instanceof HttpErrorResponse && err.status === 403) {
          window.alert("User doesn't have permission to view this document");
        }
        return Observable.throw(err);
      })
    );
  }
}
